import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import './Cult_slider.css';
// import ExampleCarouselImage from 'components/ExampleCarouselImage';
import Card from 'react-bootstrap/Card';
import Carousel_cult from './Carousel_cult';
import Carousel_cult1 from './Carousel_cult1';
import Carousel_cult2 from './Carousel_cult2';


function Cult_slider() {
    return (
        <>
           
            

            <div className="cult_slider">
                <Carousel className='cardI'> 
                    <Carousel.Item interval={1000} className='cardS'>
                       
                        <Carousel_cult/>
                    </Carousel.Item>
                    <Carousel.Item interval={1200}className='cardS'>
                        <Carousel_cult1/>
                    </Carousel.Item>
                    <Carousel.Item interval={1200} className='cardS'>
                      <Carousel_cult2/>
                    </Carousel.Item>
                </Carousel>
            </div>
            


        </>
    )
}

export default Cult_slider;
